import Menu from '@mui/material/Menu';
import styled from 'styled-components';

export const CustomMenu = styled(Menu)``;
